export * from './invite-to-dm-page.component';
export * from './invite-to-dm-page.module';
